<template>
  <div class="index">
    <div class="banner">
      <div>{{ $t('lang.home31') }} Diffie</div>
      <div>{{ $t('lang.home32') }} {{ $t('lang.home33') }}</div>
      <div class="img">
        <div>Diffie</div>
        <div style="color: #F2682B; font-size: 24px; margin-top: 4px;">{{ $t('lang.home34') }}</div>
        <img src="@/assets/img/img_abs.png" class="img_abs" alt="">
      </div>

    </div>
    <div class="functional_region">
      <div class="region">
        <div v-for="(item, index) of functionOption" :key="index" @click="switchovers(item)"
          :class="item.router.includes($route.name) ? 'special' : ''">
          <span>{{ $t(item.name) }}</span>
        </div>
      </div>
    </div>
    
    <div class="box">
      <router-view />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      // 功能列表
      functionOption: [{ name: 'lang.swap77', router: ['Swap'] }, { name: 'lang.swap78', router: ['LiquidityIndex', 'importMining', 'Liquidity', 'Remove'] }, { name: 'lang.home35', router: ['CrossChainBridge'] }],
      regionIndex: '0',
    };
  },
  created() {
  },
  mounted() {

  },
  methods: {
    switchovers(val) {
      if (val.router) {
        this.$router.push({ name: val.router[0] });
      }
    },
  },
};
</script>

<style lang="less" scoped>
.index {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.banner {
  width: 100%;
  padding: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;

  &>div {
    font-weight: bold;
  }

  &>div:nth-child(1) {
    font-size: 24px;
    color: #FFFFFF;
    margin-bottom: 5px;
  }

  &>div:nth-child(2) {
    font-size: 18px;
    color: #676667;
    margin-bottom: 43px;
  }

  .img {
    position: relative;
    width: 100%;
    background: url('~@/assets/img/swap_banner.png') no-repeat;
    background-size: contain !important;
    height: 112px;
    display: flex;
    flex-direction: column;
    align-items: start;
    padding: 23px 19px;

    .img_abs {
      right: 0px;
      bottom: 0px;
      position: absolute;
      width: 164px;
      height: 151px;
    }
  }
}

.box {
  flex: 1;
  margin: 14px;
  border-radius: 20px;
  background: linear-gradient(143.12deg, rgba(78, 29, 5, 0.42) 0%, rgba(8, 3, 2, 1) 100%);

  border: 1px solid #B3542C;
}

.functional_region {
  padding: 20px 20px 0;
  padding-top: 0;

  .region {
    display: flex;
    width: 100%;
    line-height: 22px;
    font-size: 16px;
    color: #F3BFA9;
    font-weight: 600;
    padding: 2px;
    background: #E06029;
    border-radius: 30px;
    // margin: 20px 0;
    margin-bottom: 20px;

    div {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 50%;
      // width: 192rpx;
      padding: 7px 0;
    }

    .special {
      // width: 50%;
      color: #fff;
      background: #070101;
      // box-shadow: 0px 1px 0px 0px rgba(1, 17, 29, 0.73);
      border-radius: 30px;
    }
  }
}

/deep/ .router {
  background: #000 !important;
}
</style>